import { truncate } from 'lodash/fp';
import Link from '../../../../Link';
const MAX_LEN = 50;

export default function PlainLink({ link, text }) {
    const body = text || link;
    return (
        <Link openInNewTab={true} href={link}>
            {truncate({ length: MAX_LEN }, body)}
        </Link>
    );
}
